export const GARMENT_CATEGORIES = [
  'Tops',
  'Bottoms',
  'Dresses',
  'Outerwear',
  'Shoes',
  'Bags',
  'Accessories',
  'Traditional',
  'Activewear',
  'Other',
] as const;

export const SEASONS = ['All season', 'Summer', 'Monsoon', 'Winter'] as const;

export const OCCASIONS = [
  'Everyday',
  'Work',
  'Date night',
  'Party',
  'Wedding',
  'Travel',
  'Workout',
] as const;

export type GarmentCategory = (typeof GARMENT_CATEGORIES)[number];
export type Season = (typeof SEASONS)[number];
export type Occasion = (typeof OCCASIONS)[number];

export interface ShoppingSource {
  kind: 'shopping-link';
  url: string;
  store: string;
  productId: string | null;
  variantId: string | null;
  size: string | null;
  color: string | null;
  listedPriceMinor: number | null;
  currency: string | null;
  importedAt: number;
}

export interface WardrobeItem {
  id: string;
  name: string;
  category: GarmentCategory;
  primaryColor: string;
  brand: string | null;
  material: string | null;
  notes: string | null;
  seasons: Season[];
  occasions: Occasion[];
  favorite: boolean;
  archived: boolean;
  photoUrl: string;
  source?: ShoppingSource | null;
  createdAt: number;
  updatedAt: number;
}

export interface WardrobeItemInput {
  name: string;
  category: GarmentCategory;
  primaryColor: string;
  brand?: string;
  material?: string;
  notes?: string;
  seasons: Season[];
  occasions: Occasion[];
  favorite?: boolean;
}

export interface WardrobeItemsResponse {
  items: WardrobeItem[];
}

export interface WardrobeItemResponse {
  item: WardrobeItem;
}
